import React, { useEffect, useState } from 'react';

// helpers
import { useMainLayoutContext } from 'modules/Layouts/MainLayout/MainLayoutContext';

// components
import AddSecurityKey from '../../modules/Profile/Security/TwoFactorAuthentication/ManageSecurityKeys/AddSecurityKey';
import PageContentCard from 'modules/Layouts/MainLayout/PageRenderer/PageContentCard';
import ManageSecurityKeysTable from '../../modules/Profile/Security/TwoFactorAuthentication/ManageSecurityKeys/ManageSecurityKeysTable';

const ManageSecurityKeys = () => {
  const { setPageLayoutOptions, clearContext } = useMainLayoutContext();
  const [updateKeysTrigger, updateKeys] = useState({});

  useEffect(() => {
    setPageLayoutOptions((prev) => ({
      ...prev,
      extra: () => <AddSecurityKey onAdd={() => updateKeys({})} />,
    }));
    return () => clearContext();
  }, [setPageLayoutOptions, clearContext]);

  return (
    <PageContentCard>
      <ManageSecurityKeysTable updateTableTrigger={updateKeysTrigger} />
    </PageContentCard>
  );
};

export default ManageSecurityKeys;
